import React, { useMemo } from 'react'
import { Typography } from '@mui/material'
import { addMonths } from 'date-fns'
import useFavurTranslation from 'hooks/useFavurTranslation'
import TableBackgroundContainer from 'pages/AbsencePlanner/components/Grid/TableBackgroundContainer/TableBackgroundContainer'
import CloseButton from 'redesign/components/atoms/Buttons/CloseButton'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { formatDate } from 'redesign/shared/date/utils'
import { Container } from './styles'
import type { AbsencePlanDrawerHeaderProps } from './types'

const AbsencePlanDrawerHeader: React.FC<AbsencePlanDrawerHeaderProps> = ({ onCancel, baseDate, shownMonthIndex }) => {
  const { t, locale } = useFavurTranslation()
  const currentDate = useMemo(
    () => (shownMonthIndex !== undefined ? addMonths(baseDate, shownMonthIndex) : baseDate),
    [baseDate, shownMonthIndex],
  )

  return (
    <Container>
      <TableBackgroundContainer>
        <Typography variant="body1" data-testid="absence-planner-shown_month">
          {formatDate({ date: currentDate, locale, t, dateFormat: DATE_FORMAT_VARIANTS.monthOnly })}
        </Typography>
      </TableBackgroundContainer>
      <CloseButton onClick={onCancel} size="large" />
    </Container>
  )
}

export default AbsencePlanDrawerHeader
